import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { gridSizeMdLg11, useTabsFormOnly } from '@/shared';
import {
  CustomTabPanel,
  TabsFormBoxScene,
} from '@/shared/components/ui';
import type { Cliente, Contrato, IDataPreventa } from '@/shared/interfaces';
import ClientesFibraFormTabsOnly from '../ClientesFibraFormTabsOnly';
import ClienteFibraFormTitle from './ClienteFibraFormTitle';
import ClienteFibraServiceFormTab from './ClienteFibraServiceFormTab';
import ClienteFibraSummaryTFormab from './ClienteFibraSummaryTFormab';
import { ClienteFibraDocsFormTab } from './docs';
import { ClienteFibraPromocionesFormTab } from './promociones';
import { ClienteFibraSurveyFormTab } from './survey';
import TrazabilidadLogFormTab from './trazabilidad-log/TrazabailidadLogFormTab';

export type SaveContractFibraProps = {
  contract: Contrato;
};

/// TODO: interfaz con el nombre ya existe
export type ClienteFibraSummaryFormType = Contrato &
  Cliente &
  IDataPreventa & {
    planLabel: string;
    permanencia: string;
    numero_contrato: string; // num ref contrato
  };

const SaveContractFibra: React.FC<SaveContractFibraProps> = ({ contract }) => {
  ///* hooks -------------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });


  ///* form -------------------------
  const form = useForm<ClienteFibraSummaryFormType>();

  ///* effects -------------------------
  useEffect(() => {
    if (!contract) return;

    const {
      cliente_data,
      preventa_data,
      orden_trabajo_data,
      agendamiento_data,

      ...rest
    } = contract || {};

    form.reset({
      ...(preventa_data || {}),
      ...(agendamiento_data || {}),
      ...(orden_trabajo_data || {}),
      ...(cliente_data || {}),
      ...rest,

      //
      planLabel: contract?.plan_data?.nombre || '',
      permanencia: contract?.tiempo_contrato ? `${contract?.tiempo_contrato} MESES` : contract?.plan_data?.permanencia || '',
      numero_contrato: contract?.numero_referencia || '',

      //
      observacion_1:
        orden_trabajo_data?.preventa_data?.observaciones?.observacion_1,
      observacion_2:
        orden_trabajo_data?.preventa_data?.observaciones?.observacion_2,
      observacion_llamada:
        agendamiento_data?.observaciones?.observacion_llamada,

      observacion_tecnico:
        orden_trabajo_data?.observaciones?.observacion_tecnico || '',
      observacion_activacion:
        orden_trabajo_data?.observaciones?.observacion_activacion || '',

      fecha_instalacion:agendamiento_data?.fecha_instalacion,


    } as unknown as ClienteFibraSummaryFormType);
  }, [contract]);

  return (
    <TabsFormBoxScene
      titlePage="" // only for typescript
      titlePageNode={<ClienteFibraFormTitle contract={contract!} showRejectButton={true} />}
      // size={gridSizeMdLg10} // actual form container size
      showBtns={false}
      // // custom btns
      size={gridSizeMdLg11}
      showCustomBtns
      /* customBtns={
        <Grid container justifyContent="flex-start" mt={5}>
          <SingleButton
            variant="text"
            label="Regresar"
            onClick={() => {
              navigate(clientesFibraOpticaReturnUrl);
            }}
          />
        </Grid>
      } */
      // // tabs
      tabs={
        <ClientesFibraFormTabsOnly
          valueTab={valueTab}
          handleMethodChange={handleMethodChange}
        />
      }
    >
      {/* =================== summary =================== */}
      <CustomTabPanel index={valueTab} value={1}>
        <ClienteFibraSummaryTFormab contract={contract} form={form} />
      </CustomTabPanel>

      {/* =================== service / instalacion / ot =================== */}
      <CustomTabPanel index={valueTab} value={2}>
        <ClienteFibraServiceFormTab contract={contract} form={form} />
      </CustomTabPanel>


      {/* =================== documents and photos =================== */}
      <CustomTabPanel index={valueTab} value={5}>
        <ClienteFibraDocsFormTab contract={contract} />
      </CustomTabPanel>

      {/* =================== encuesta =================== */}
      <CustomTabPanel index={valueTab} value={6} justifyContent='left'>
        <ClienteFibraSurveyFormTab contract={contract} />
      </CustomTabPanel>

      {/* =================== logs =================== */}
      <CustomTabPanel index={valueTab} value={7}>
        <TrazabilidadLogFormTab contract={contract} />
      </CustomTabPanel>

      {/* =================== promociones =================== */}
      <CustomTabPanel index={valueTab} value={8}>
        <ClienteFibraPromocionesFormTab contract={contract} />
      </CustomTabPanel>
    </TabsFormBoxScene>
  );
};

export default SaveContractFibra;
